import { Refresh } from '@mui/icons-material';
import { Alert, Button, useTheme } from '@mui/material';

import Typography from '@/components/Typography';
import { useVersionPolling } from '@/hooks/api/version';

export const VersionUpdateBanner = () => {
  const { hasNewVersion } = useVersionPolling();

  const handleRefresh = () => {
    window.location.reload();
  };

  const theme = useTheme();

  if (!hasNewVersion) {
    return null;
  }

  return (
    <Alert
      action={
        <Button
          size='small'
          sx={{
            backgroundColor: `${theme.palette.text.primary}33`,
            fontSize: '12px',
            width: '124px'
          }}
          onClick={handleRefresh}
        >
          <Typography
            size={12}
            sx={{
              textWrap: 'nowrap'
            }}
          >
            Refresh now
          </Typography>
        </Button>
      }
      iconMapping={{
        info: <Refresh fontSize='inherit' />
      }}
      severity='info'
      sx={{
        borderRadius: 0,
        backgroundColor: '#E84E0F',
        color: 'white',
        marginBottom: 2,
        gap: 0,
        '& .MuiAlert-icon': {
          color: 'white',
          opacity: 1,
          marginRight: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        '& .MuiAlert-action': {
          padding: 0,
          paddingLeft: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: 0
        },
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center'
        }
      }}
    >
      <Typography
        fontWeight='bold'
        size={14}
        sx={{
          marginRight: '12px'
        }}
      >
        New version available
      </Typography>
      <Typography size={12}>
        Please refresh the page to ensure optimal performance and access the latest features
      </Typography>
    </Alert>
  );
};
